<template>
    <div>
      <CurrentLocationPanel v-if="currentProgress !== 'action'" />
      <div class="system-panel-wrapper">
        <confirmMaxStock 
          v-if="currentProgress === 'setMaxStock'" 
          v-on:setMaxAmountData="getMaxAmountData">
        </confirmMaxStock>

        <confirmExpirationDate 
          v-if="currentProgress === 'setExpiredDate'" 
          v-on:setExpirationDate="getExpirationDate">
        </confirmExpirationDate>
      </div>
      <Action
        v-if="currentProgress === 'action'" 
        :defaultNum="maxAmount"
        :deviceId="$store.state.device.currentDevice.id"
        :autoCaculateAmount="true"
        :checkNum="maxAmount"
        :limitPackCount="false"
        v-on:setActionData="getActionData">
        <h6>此藥盒新增數量</h6>
      </Action>
      <Loader v-if="currentProgress === 'next'"/>
    </div>
</template>

<script>
/*
  This component collect the data from the flowComp and emit to Multiflow compoment.
*/
import confirmMaxStock from '../flowComp/MaxStockSet';
import confirmExpirationDate from '../flowComp/DateSelection';
import confirmStorage from '../flowComp/NumberSet';
import Action from '../flowComp/Action';
import Loader from '../common/Loader';
import CurrentLocationPanel from '../flowComp/CurrentLocationPanel';
import ConfirmFlowBase from '../ComponentBase/ConfirmFlowBase';

export default {
  name: 'confirmFlow',
  extends: ConfirmFlowBase,
  data() {
    return {
      maxAmount: 0,
      patchNumber: '',
      expirationDate: '',
      storageAmount: 0,
      actionData: {},
    };
  },
  components: {
    confirmMaxStock,
    confirmExpirationDate,
    confirmStorage,
    Action,
    Loader,
    CurrentLocationPanel,
  },
  methods: {
    getMaxAmountData(amountData) {
      this.maxAmount = amountData.amount;
      this.patchNumber = amountData.patchNumber;
      this.nextProgress();
      this.$store.commit('SET_CURRENT_STEP', 'setExpiredDate');
    },
    getExpirationDate(date) {
      this.expirationDate = date;
      this.nextProgress();
    },
    getActionData(data) {
      this.actionData = data;
      this.nextProgress();
      const postData = {
        device: this.currentDevice.id,
        medication: this.selectedDrug.id,
        max_stock: this.maxAmount,
        patch_number: this.patchNumber,
        expired_date: this.expirationDate,
        stock: this.actionData.num,
        pack_count: this.actionData.packCount,
        number1: this.actionData.num,
        type: 'LOAD', // event type: for event recording
      };

      this.instance.post('/api/drug-storage/', postData)
      .then(() => {
        this.$emit('confirmationFinish');
        this.resetProgress();
      });
    },
  },
  computed: {
    selectedDrug() {
      return this.$store.state.drug.selectedDrug;
    },
  },
};
</script>

<style lang="sass">
.system-panel-wrapper
  .confirm-form
    height: 260px !important
</style>




// WEBPACK FOOTER //
// ConfirmFlow.vue?b4005ff2